/**
 * Created by Ning Jiang on 11/24/2016.
 */

import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";

export class FruitsSoundConfig implements ISoundConfig {

    public static instance:FruitsSoundConfig = new FruitsSoundConfig();
    static AS_WIN:string="asWin";
    static AS_WIN_BIG:string="asWinBig";
    MAIN_GAME_AMBIANCE:string = "bgMusicMain";
    BONUS_GAME_AMBIANCE:string = "bgMusicBonus";

    REELS_SPINNING_START_ON_SPIN_START:string = "reelsSpin";
    static REELS_SPIN_BONUS:string = "reelsSpinBonus";

    REEL_BOUNCE:string = "reelLanding";
    static REEL_LANDING:string = "reelLanding";
    static B_LANDING:string = "lightningBSymbolLanding";

    static WIN_TINY:string = "winTiny";
    static WIN_SMALL:string = "winSmall";
    static WIN_MEDIUM:string = "winMedium";
    static WIN_LARGE:string = "winLarge";

    static WILD_ATTENTION:string = "wildAttention";

    static SCATTER_ATTENTION:string = "scatterAttention";
    static SCATTER_WIN:string = "scatterWin";

    static WIN_ATTENTION1:string = "winAttention1";
    static WIN_ATTENTION2:string = "winAttention2";
    static WIN_ATTENTION3:string = "winAttention3";
    static WIN_ATTENTION4:string = "winAttention4";

    static COUNTUP:string = "countup";
    static COUNTUP_ENDS:string = "countupEnds";

    static BIG_WIN_FADE_IN:string = "bigwinFadeIn";
    static BIG_WIN:string = "bigwin";
    static BIG_WIN_ENDS_1:string = "bigwinEnds1";
    static BIG_WIN_ENDS_2:string = "bigwinEnds2";
    static BIG_WIN_ENDS_3:string = "bigwinEnds3";
    static BIG_WIN_ENDS_HIT_2:string = "bigwinEndsHit2";
    static BIG_WIN_ENDS_HIT_3:string = "bigwinEndsHit3";

    static STICKY_ANTICIPATION:string = "stickyAnticipation";
    static STICKY_REEL_LANDING:string = "stickyReelLanding";
    static STICKY_SPLASH_SCREEN:string = "stickySplashScreen";
    static STICKY_SYMBOLS_COLLIDE:string = "stickySymbolsCollide";
    static STICKY_SYMBOL_TRANSITION:string = "stickySymbolTransition";
    static STICKY_NO_WIN:string = "stickyNoWin";
    static STICKY_ENDS:string = "stickyEnds";

    static LIGHTNING_INTRO_HIT_1:string = "lightningIntroHit1";
    static LIGHTNING_INTRO_HIT_2:string = "lightningIntroHit2";
    static LIGHTNING_INTRO_SPLASH:string = "lightningIntroSplash";
    static LIGHTNING_INFO_PLING:string = "lightningInfoPling";

    static LIGHTNING_LEVEL_UP:string = "lightningLevelUp";
    static LIGHTNING_PLUS_ONE:string = "lightningPlusOne";
    static LIGHTNING_METER_UP:string = "lightningMeterUp";
    static LIGHTNING_NEW_LEVEL:string = "lightningMeterNewLevel";
    static LIGHTNING_SWEEP:string = "lightningSweep";
    static LIGHTNING_METER_LEVEL_UP:string = "lightningMeterLevelUp";
    static LIGHTNING_PLUS_ONE_KEYPAD:string = "lightningPlusOneKeypad";
    static LIGHTNING_ENDS:string = "lightningEnds";
    static LIGHTNING_COUNT_UP_GLITTER:string = "lightningCountupGlitter";

    static BONUS_SWEEP_1:string = "bonusSweep1";
    static BONUS_SWEEP_2:string = "bonusSweep2";

    static WRAPPER:string = "wrapper";
    static WRAPPERS_POP:string = "wrappersPop";

    static ANTICIPATION:string = "anticipation";
    static ANTICIPATION_FAIL:string = "anticipationFail";

    static BETLINE:string = "betline";

    constructor() {
        if(FruitsSoundConfig.instance) {
            throw new Error("FruitsSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}